export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8728.784d3fe2.jpg";